import { FC } from 'react';
import clsx from 'clsx';
import { setHeaderStage } from 'entities/viewStage';
import { useHistoryOfViewStage } from 'shared/hooks';
import { useAppDispatch, useAppSelector } from 'shared/lib';

import styles from './styles.module.scss';
export const Navigation: FC = () => {
  const dispatch = useAppDispatch();
  const { headerSwitchStage } = useAppSelector(
    (state) => state.viewStageReducer,
  );
  const { setViewStageHistory } = useHistoryOfViewStage();
  return (
    <div className={styles['buttons-select']}>
      <button
        className={clsx(styles['buttons-select__item'], styles['schedule'], {
          [styles['buttons-select_active']]: headerSwitchStage === 'schedule',
        })}
        onClick={() => {
          dispatch(setHeaderStage('schedule'));
          setViewStageHistory('schedule');
        }}
      >
        Расписание занятий
      </button>
      <button
        className={clsx(styles['buttons-select__item'], styles['exams'], {
          [styles['buttons-select_active']]: headerSwitchStage === 'exams',
        })}
        onClick={() => {
          dispatch(setHeaderStage('exams'));
          setViewStageHistory('exams');
        }}
      >
        Экзамены
      </button>
    </div>
  );
};
